import React from 'react';
export function FinalCTA() {
  return <section className="w-full bg-fondo-principal text-white py-section px-4 text-center" data-id="element-61">
      <h2 className="text-2xl font-bold mb-8 leading-tight" data-id="element-62">
        La próxima vez que agarres la guitarra, vas a saber exactamente qué
        hacer. 🎸
      </h2>

      <div className="flex flex-col gap-4 mb-8" data-id="element-63">
        <button onClick={() => document.getElementById('pricing')?.scrollIntoView({
        behavior: 'smooth'
      })} className="w-full h-[56px] bg-botones-acentos hover:bg-orange-500 text-white font-bold rounded-xl text-lg transition-colors flex items-center justify-center gap-2" data-id="element-64">
          🎸 Quiero el Sistema Guitarra Fácil
        </button>
        <button onClick={() => document.getElementById('pricing')?.scrollIntoView({
        behavior: 'smooth'
      })} className="w-full h-[56px] bg-transparent border-2 border-white/30 hover:border-white text-white font-semibold rounded-xl text-base transition-colors flex items-center justify-center" data-id="element-65">
          🚀 Quiero el Plan PRO
        </button>
      </div>

      <div className="flex flex-wrap justify-center items-center gap-x-4 gap-y-2 text-xs text-gray-300" data-id="element-66">
        <span className="flex items-center gap-1" data-id="element-67">✅ Garantía 7 días</span>
        <span data-id="element-68">·</span>
        <span className="flex items-center gap-1" data-id="element-69">🔒 Pago seguro</span>
        <span data-id="element-70">·</span>
        <span className="flex items-center gap-1" data-id="element-71">⚡ Acceso inmediato</span>
      </div>
    </section>;
}